import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    shelfLocations: [],   // 纱架位置列表
    currYarnOpt: {},      // 纱架最近一次挂换纱操作
    iTouchUse: false,     // iTouch使用区分
  },
  mutations: {
    setShelfLocations(state, provider) {
      state.shelfLocations = provider;
    },
    setShelfLocation(state, provider) {
      var index = state.shelfLocations.findIndex(loc => loc.locno==provider.locno);
      if (index != -1) {
        Vue.set(state.shelfLocations, index, provider);
      }
    },
    setCurrYarnOpt(state, provider) {
      state.currYarnOpt = provider;
    },
    setITouchUse(state, provider) {
      state.iTouchUse = provider;
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js